import React from 'react';

import './App.css';

import Header from '../components/header/Header.js';
import { Outlet } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Header />
      <div className='container'>
        <Outlet />
      </div>
    </div>
  );
}

export default App;
